export default {
  'paymentRule.allSelected': 'All Selected',
  'paymentRule.addHeader': 'Add Payment Rule',
  'paymentRule.accountIsDeactivated': 'Account is deactivated',
  'paymentRule.modifyHeader': 'Modify Payment Rule',
  'paymentRule.viewHeader': 'View Payment Rule',
  'paymentRule.selectRuleType': 'Select Rule Type',
  'paymentRule.dualControlHeader': 'Approve/Reject Rule Changes',
  'paymentRule.approveRejectChanges': 'Approve/Reject Changes',
  'paymentRule.accept': 'Accept',
  'paymentRule.pay': 'Pay',
  'paymentRule.capitalize.PAY': 'Pay',
  'paymentRule.capitalize.RETURN': 'Return',
  'paymentRule.return': 'Return',
  'paymentRule.addRule': 'Rule added successfully',
  'paymentRule.deleteRuleHeader': 'Delete Rule',
  'paymentRule.confirmationMsgStart': 'You are about to',
  'paymentRule.deletePaymentRule': 'Delete Payment Rule',
  'paymentRule.confirmationMsgEnd':
    'for <%= originatorName %> and this action cannot be undone. Do you wish to proceed?',

  'paymentRule.originatorNameDuplicateLabel': '(Originator ID: <%=originatorId %>)',
  'paymentRule.originatorId': 'Originator Id',
  'paymentRule.originatorCompanyId': 'Originator Company Id',
  'paymentRule.originatorName': 'Originator Name',
  'paymentRule.originatorCompanyName': 'Originator Company Name',
  'paymentRule.setMaxAmount': 'Set max amount',
  'paymentRule.maxAmount': 'Max amount',
  'paymentRule.setMinAmount': 'Set min amount',
  'paymentRule.minAmount': 'Min amount',
  'paymentRule.maxAmountSet': 'Max amount set',
  'paymentRule.timing': 'Timing',
  'paymentRule.addSchedule': 'Assign Accept Timing',
  'paymentRule.assignTiming': 'Assign Timing',
  'paymentRule.clearSchedule': 'Clear Timing',
  'paymentRule.acceptTiming': 'Accept Timing',
  'paymentRule.accountNameAndNumber': 'Account',
  'paymentRule.ruleAlreadyExists': 'Rule already exists',
  'paymentRule.ruleAdded': 'Rule added successfully',
  'paymentRule.ruleDeleted': 'Rule has been deleted',

  'paymentRule.invalidAmount': 'Amount must be greater than 0.00',
  'paymentRule.selected': '<%=number %> Selected',
  'paymentRule.multi': 'MULTI (<%=number %>)',
  'paymentRule.inuse': 'inuse',

  'paymentRule.debit': 'Debit',
  'paymentRule.credit': 'Credit',
  'paymentRule.delete': 'Delete',
  'paymentRule.viewRule': 'View Rule',
  'paymentRule.viewModifications': 'View Rule Modifications',
  'paymentRule.modify': 'Modify',
  'paymentRule.copy': 'Copy As New Rule',
  'paymentRule.accountName': 'Account Name',
  'paymentRule.accountNumber': 'Account Number',
  'paymentRule.approvalStatus': 'Approval Status',
  'paymentRule.exceptionDecision': 'Exception Decision',
  'paymentRule.effectiveDate': 'Effective Date',
  'paymentRule.amount': 'Amount',
  'paymentRule.ruleType': 'Rule Type',
  'paymentRule.ruleStatus': 'Rule Status',
  'paymentRule.startDate': 'Start Date',
  'paymentRule.setEndDate': 'Set End Date',
  'paymentRule.endDate': 'End Date',
  'paymentRule.setPaymentWindow': 'Set Payment Window',
  'paymentRule.paymentWindow': 'Payment Window',
  'paymentRule.onThe': 'On the',
  'paymentRule.range': 'Range',
  'paymentRule.singleDay': 'Single Day',
  'paymentRule.occurrence': 'Occurrence',
  'paymentRule.everyMonth': 'Every Month',
  'paymentRule.endDateBeBeforeStart': 'End date cannot be before <%= startDate %>.',
  'paymentRule.startDateValidation': 'Start date cannot be before <%= today %>.',
  'paymentRule.transactions': 'Transactions',
  'paymentRule.rules': 'Rules',
  'paymentRule.activeInUse': 'Active/In Use',
  'paymentRule.originatorNameAndIdDoesNotMatch': 'Originator Name and Originator ID do not match',
  'paymentRule.viewMore': 'View more',
  'paymentRule.viewLess': 'View less',

  'paymentRule.APPROVED': 'Approved',
  'paymentRule.REJECTED': 'Rejected by approver',
  'paymentRule.APPROVE': 'Approve',
  'paymentRule.REJECT': 'Reject',
  'paymentRule.status.APPROVED': 'approved',
  'paymentRule.status.REJECTED': 'rejected',
  'paymentRule.REQUIRES_OTHERS_APPROVAL': "Requires other's approval",
  'paymentRule.REQUIRES_MY_APPROVAL': 'Requires my approval',
  'paymentRule.INUSE': 'Active/In Use',
  'paymentRule.ACTIVE': 'Active',
  'paymentRule.INACTIVE': 'Inactive',
  'paymentRule.INACTIVEDC': 'Inactive',
  'paymentRule.EXPIRED': 'Expired',
  'paymentRule.DELETED': 'Deleted',
  'paymentRule.PENDING': 'Pending',
  'paymentRule.failedToCompleteMsg':
    'Action "<%= action %>" failed to complete. Rule <%= approvalStatus %> by <%= username %> on <%= dateTime %>',

  // modify
  'paymentRule.ruleSubmittedForApproval': 'Rule has been submitted for approval.',
  'paymentRule.ruleModified': 'Rule changed successfully',
  'paymentRule.ruleTypeChange': 'RULE TYPE CHANGE',

  // validation
  'paymentRule.currentRuleTransactionsOnly':
    'Modifying this rule will impact the following transactions.',
  'paymentRule.otherRules': 'Modifying this rule will impact the following rules.',
  'paymentRule.otherRulesAndTransactions':
    'Modifying this rule will impact the following rules and transactions.',

  // Grid timing
  'paymentRule.timingGridSingleDay': 'On the <%= firstDay %> of every month',
  'paymentRule.timingGridRange': 'From <%= firstDay %> until <%= lastDay %> every month',
  'ACHPOSPAY.ORIGINATOR_NAME_DOES_NOT_MATCH': 'Originator Name does not match.',

  'paymentRule.timingSingleDate':
    'Monthly on the <%= firstDay %> from <%= startDate %> until <%= endDate %>.',
  'paymentRule.timingRangeDate':
    'Monthly from <%= firstDay %> to <%= lastDay %> starting from <%= startDate %> until <%= endDate %>.',
  'paymentRule.timingNoRange': 'Monthly from <%= startDate %> until <%= endDate %>.',
  'paymentRule.cancelled': 'cancelled',

  'paymentRule.confirmRuleDetails': 'Confirm rule details',
  'paymentRule.paymentInformation': 'Payment Information',
  'paymentRule.selectedAccounts': 'Selected Accounts',
  'paymentRule.allowedAmountLimit': 'Amount limit allowed for this rule',
  'paymentRule.paymentMethod': 'Payment Method',
  'paymentRule.timingAssigned': 'Timing Assigned'
};
